import { Image, List } from "antd";
import { Content } from "antd/lib/layout/layout";
import EscudoAlcaldiaBlanco from "../../../assets/landing/medellin.png";
import './style.scss';

const numerosEnPalabras: string[] = [
  'Cero', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve',
  'Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve',
  'Veinte', 'Veintiuno', 'Veintidós', 'Veintitrés', 'Veinticuatro', 'Veinticinco', 'Veintiséis', 'Veintisiete', 'Veintiocho', 'Veintinueve',
  'Treinta', 'Treinta y uno', 'Treinta y dos', 'Treinta y tres', 'Treinta y cuatro', 'Treinta y cinco', 'Treinta y seis', 'Treinta y siete', 'Treinta y ocho', 'Treinta y nueve',
  'Cuarenta', 'Cuarenta y uno', 'Cuarenta y dos', 'Cuarenta y tres', 'Cuarenta y cuatro', 'Cuarenta y cinco', 'Cuarenta y seis', 'Cuarenta y siete', 'Cuarenta y ocho', 'Cuarenta y nueve',
  'Cincuenta', 'Cincuenta y uno', 'Cincuenta y dos', 'Cincuenta y tres', 'Cincuenta y cuatro', 'Cincuenta y cinco', 'Cincuenta y seis', 'Cincuenta y siete', 'Cincuenta y ocho', 'Cincuenta y nueve',
  'Sesenta', 'Sesenta y uno', 'Sesenta y dos', 'Sesenta y tres', 'Sesenta y cuatro', 'Sesenta y cinco', 'Sesenta y seis', 'Sesenta y siete', 'Sesenta y ocho', 'Sesenta y nueve',
  'Setenta', 'Setenta y uno', 'Setenta y dos', 'Setenta y tres', 'Setenta y cuatro', 'Setenta y cinco', 'Setenta y seis', 'Setenta y siete', 'Setenta y ocho', 'Setenta y nueve',
  'Ochenta', 'Ochenta y uno', 'Ochenta y dos', 'Ochenta y tres', 'Ochenta y cuatro', 'Ochenta y cinco', 'Ochenta y seis', 'Ochenta y siete', 'Ochenta y ocho', 'Ochenta y nueve',
  'Noventa', 'Noventa y uno', 'Noventa y dos', 'Noventa y tres', 'Noventa y cuatro', 'Noventa y cinco', 'Noventa y seis', 'Noventa y siete', 'Noventa y ocho', 'Noventa y nueve', 'Cien'
];

export const obtenerLetras = (num: number): string => {
  if (num >= 0 && num <= 100) return numerosEnPalabras[num];
  return 'Sin dato';
};

export type PlanillaTemplateProps = {
  datos: any;
  juradosCriterios: any[];
  informeEvaluacion: string;
  idPrefix?: string;
};

export const PlanillaTemplate = ({ datos, juradosCriterios, informeEvaluacion, idPrefix = '' }: PlanillaTemplateProps) => {
  const sumatoriaTotalRedondeado = parseFloat(
    juradosCriterios.reduce((total, j) => {
      return total + j.criterios.reduce((ct: number, c: any) => ct + c.nota, 0) / juradosCriterios.length;
    }, 0).toFixed(2)
  );

  return (
    <Content className="category_mdl_box">
      <Content className="cat_listing">
        {[...juradosCriterios]
          .sort((a: any, b: any) => a.primer_nombre.localeCompare(b.primer_nombre))
          .map((j: any, idx: number) => {
            const sumatoriaNotas = j.criterios.reduce((total: number, c: any) => total + c.nota, 0);
            const sortedCriterios = [...j.criterios].sort((a: any, b: any) => a.id - b.id);
            const juradoKey = j.id_jurado ?? j.primer_nombre ?? idx;
            return (
              <List
                id={`${idPrefix}jurado_eval_${idx}`}
                key={juradoKey}
                style={{ paddingTop: "5px", paddingBottom: "5px" }}
                itemLayout="horizontal"
                dataSource={sortedCriterios}
                header={
                  <div>
                    <div className="container-fluid border bg-light p-4">
                      <div className="row">
                        <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%" }} preview={false} />
                        <br /><br />
                        <span className="md-title-text text-center font-size-16px">
                          <br />
                          SECRETARÍA DE CULTURA CIUDADANA
                        </span>
                        <br />
                        <span className="md-title-text text-center font-size-16px">
                          CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
                        </span>
                      </div>
                      <br /><br />
                      <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="col-12 col-md-6 col-lg-3">
                          <div className="row">
                            <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">Nombre</div>
                            <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">{datos.nombre_propuesta}</div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                          <div className="row">
                            <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">Código</div>
                            <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">{datos.radicado}</div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                          <div className="row">
                            <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">Línea</div>
                            <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">{datos.linea_convocatoria}</div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                          <div className="row">
                            <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">Categoría</div>
                            <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">{datos.categoria_linea_convocatoria}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <List.Item style={{ background: '#ae3e97' }}>
                      <List.Item.Meta
                        className="list_cat"
                        title={
                          <span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding: "10px", color: "white" }}>
                            Jurado:{" "}<span style={{ fontWeight: 'bold' }}>
                              {` ${j.primer_nombre} ${j.segundo_nombre || ''} ${j.primer_apellido} ${j.segundo_apellido || ''}`}
                            </span>
                          </span>
                        }
                      />
                    </List.Item>
                  </div>
                }
                footer={
                  <div>
                    <List.Item style={{ background: '#faad1424' }}>
                      <List.Item.Meta
                        className="list_cat"
                        title={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding: "10px" }}>Puntaje total:</span>}
                        description={
                          <span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding: "10px" }}>
                            Puntaje total en letras: <span style={{ fontWeight: 'bold' }}>{obtenerLetras(sumatoriaNotas)}</span>
                          </span>
                        }
                      />
                      <div className="font-size-16px" style={{ padding: "10px", fontWeight: 'bold', color: "black" }}>{sumatoriaNotas}</div>
                    </List.Item>
                    <div className="row">
                      {j.src && <Image src={j.src} style={{ maxWidth: "15%" }} preview={false} />}
                    </div>
                    <div className="text-center font-size-16px">{informeEvaluacion}</div>
                    <hr />
                    <div className="font-family-Montserrat-Bold font-size-16px" style={{ marginLeft: '80%' }}>
                      Puntaje promedio: {sumatoriaTotalRedondeado}
                    </div>
                    <div id={`${idPrefix}footer_${idx}`}></div>
                  </div>
                }
                renderItem={(item: any, index: number) => (
                  <List.Item key={item.id || item.nombre} style={{ background: index % 2 === 0 ? '#f0f0f0' : 'white' }}>
                    <List.Item.Meta
                      className="list_cat"
                      title={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px">{item.nombre}</span>}
                      description={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ fontWeight: 'bold' }}>{item.observaciones}</span>}
                    />
                    <div className="font-size-16px" style={{ padding: "10px", fontWeight: 'bold' }}>{item.nota}</div>
                  </List.Item>
                )}
              />
            );
          })}
      </Content>
    </Content>
  );
};
